import React, { useEffect, useRef } from 'react';
import { getCalApi } from "@calcom/embed-react";
import { useTheme } from '@/contexts/ThemeContext';
import { CAL_NAMESPACE, CAL_LINK, CAL_CLICK_CONFIG } from '@/config/calEmbed';

interface BookingPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Opens Cal.com's native element-click modal (matches the clean Cal popup
 * UX). Renders no DOM of its own — the parent's isOpen flag just triggers
 * Cal's modal API and listens for its close event to sync state back.
 */
const BookingPopup: React.FC<BookingPopupProps> = ({ isOpen, onClose }) => {
  const { theme } = useTheme();
  const wasOpen = useRef(false);

  useEffect(() => {
    if (!isOpen || wasOpen.current) {
      wasOpen.current = isOpen;
      return;
    }
    wasOpen.current = true;

    (async () => {
      try {
        const cal = await getCalApi({ namespace: CAL_NAMESPACE });
        cal("ui", {
          hideEventTypeDetails: false,
          layout: "month_view",
          theme: theme === 'dark' ? 'dark' : 'light',
        });
        cal("modal", {
          calLink: CAL_LINK,
          config: { ...CAL_CLICK_CONFIG, theme: theme === 'dark' ? 'dark' : 'light' },
        });
        cal("on", {
          action: "linkReady",
          callback: () => {/* noop */},
        });
        cal("on", {
          action: "__closeIframe",
          callback: () => onClose(),
        });
      } catch (e) {
        console.warn('Cal modal open failed', e);
      }
    })();
  }, [isOpen, theme, onClose]);

  return null;
};

export default BookingPopup;
